/**
 * @fileoverview Agent definition for storyline-expander-v1.
 *
 * Expands a SINGLE storyline by adding/modifying/splitting beats to reach
 * target density, enriching its summary, and generating story questions.
 *
 * Two modes:
 * - "bring to standard": fills a sparse storyline to baseline density
 * - "go beyond standard": extends an adequate storyline by ~50%
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'storyline-expander-v1',
  kind: 'primitive',
  name: 'Storyline Expander',
  description: 'Expands a single storyline by adding, modifying, or splitting beats, enriching its summary, and generating questions. Supports "bring to standard" and "go beyond standard" modes.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.plot',
    usedBy: [
      'primitives/use-storyline-expander-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'storylines-planner-v1',
      'storyline-refresher-v2',
      'storyline-extraction-pipeline-v1',
    ],
  },
};
